import { SharedModule } from '../../shared/shared.module';
import { CitizensForImpactComponent } from './citizens-for-impact.component';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CitizensForImpactListModule } from './citizens-for-impact-list/citizens-for-impact-list.module';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { ImageCropperModule } from 'ngx-image-cropper';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    ImageCropperModule,
    SharedModule,
    BsDatepickerModule,
    CitizensForImpactListModule
  ],
  declarations: [CitizensForImpactComponent],
  exports: [CitizensForImpactComponent],
  entryComponents: []
})
export class CitizensForImpactModule { }
